import { Pipe, PipeTransform } from "@angular/core";
import { EnvioDTO } from "@DTOS";
import { obtenerFechaAmigableEnvio } from "@shared/utils";

@Pipe({
    name: "fechaAmigableEnvio"
})
export class FechaAmigableEnvioPipe implements PipeTransform {

    transform(envio: EnvioDTO): string {
        return obtenerFechaAmigableEnvio(envio);
    }

}
